import {formatPrice} from '../../i18n';
import {getBetterAlternatives, payloadsOnlyDifferInSize} from '../../product';
import type {Payload, Variables} from '../../product';

export type BetterAlternative = {
    thisPayload: Payload,
    altPayload: Payload,
    priceDifference: string,
    thisSize: string,
    altSize: string,
};

export function offerBetterAlternative(
    ITEMS: Array<V1.Product>,
    VARIABLES: Variables | null,
    item: V1.Product | undefined,
    amount: number,
    sizeStep: number,
    ceilThreshold: number,
) {
    if(!item)
        return;
    const allAlternatives = getBetterAlternatives(ITEMS, item,
        ([thisItem, thisPayload]) => {
            if(thisPayload.dimension! % sizeStep == 0)
                return false;
            return thisPayload.parts[thisPayload.sizePart!].endsWith('*');
        },
        ([thisItem, thisPayload], [otherItem, otherPayload]) => {
            if(thisItem.unit_price < otherItem.unit_price)
                return false;
            if(otherPayload.dimension! % sizeStep != 0)
                return false;
            return payloadsOnlyDifferInSize(thisPayload, otherPayload);
        },
        ([thisItem, thisPayload], [otherItem, otherPayload]) => {
            var dimension = Math.floor(thisPayload.dimension! / sizeStep) * sizeStep;
            if(thisPayload.dimension! % sizeStep >= ceilThreshold)
                dimension += sizeStep;
            return Math.abs(dimension - otherPayload.dimension!);
        },
    );
    if(!allAlternatives)
        return;
    const [thisPayload, alternatives] = allAlternatives;
    const [altItem, altPayload] = alternatives[0];
    const difference = (altItem.unit_price - item.unit_price) * amount;
    let thisSize = VARIABLES!.size.options[thisPayload.parts![thisPayload.sizePart!]];
    if(typeof thisSize !== 'string')
        thisSize = thisSize.short;
    thisSize = thisSize.replaceAll(' ', "\u00a0");
    let altSize = VARIABLES!.size.options[altPayload.parts![altPayload.sizePart!]];
    if(typeof altSize !== 'string')
        altSize = altSize.short;
    altSize = altSize.replaceAll(' ', "\u00a0");
    const priceDifference = formatPrice(Math.abs(difference), {precision: 0});
    return {
        thisPayload, altPayload,
        priceDifference,
        thisSize, altSize,
    };
}
